var _rect, _g, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_995_1567",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0263672,
    width: 31.4219,
    height: 31.4219,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_995_1567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8755 9.19142V6.57293H22.257V3.95443H24.8755V1.33594H27.494V3.95443H30.1125V6.57293H27.494V9.19142H24.8755ZM14.4016 22.9385C16.0381 22.9385 17.4292 22.3657 18.5748 21.2201C19.7204 20.0745 20.2932 18.6835 20.2932 17.0469C20.2932 15.4104 19.7204 14.0193 18.5748 12.8737C17.4292 11.7281 16.0381 11.1553 14.4016 11.1553C12.765 11.1553 11.3739 11.7281 10.2283 12.8737C9.08274 14.0193 8.50995 15.4104 8.50995 17.0469C8.50995 18.6835 9.08274 20.0745 10.2283 21.2201C11.3739 22.3657 12.765 22.9385 14.4016 22.9385ZM14.4016 20.32C13.4851 20.32 12.7104 20.0036 12.0776 19.3708C11.4448 18.738 11.1284 17.9634 11.1284 17.0469C11.1284 16.1304 11.4448 15.3558 12.0776 14.723C12.7104 14.0902 13.4851 13.7738 14.4016 13.7738C15.318 13.7738 16.0927 14.0902 16.7255 14.723C17.3583 15.3558 17.6747 16.1304 17.6747 17.0469C17.6747 17.9634 17.3583 18.738 16.7255 19.3708C16.0927 20.0036 15.318 20.32 14.4016 20.32ZM3.92758 27.5209C3.20749 27.5209 2.59105 27.2645 2.07827 26.7517C1.56548 26.2389 1.30908 25.6225 1.30908 24.9024V9.19142C1.30908 8.47134 1.56548 7.8549 2.07827 7.34211C2.59105 6.82932 3.20749 6.57293 3.92758 6.57293H8.05171L10.4738 3.95443H19.6386V9.19142H22.257V11.8099H27.494V24.9024C27.494 25.6225 27.2376 26.2389 26.7249 26.7517C26.2121 27.2645 25.5956 27.5209 24.8755 27.5209H3.92758Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8501,
    y: 1.2002,
    width: 2.65,
    height: 8,
    fill: "#FF00FB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.175,
    y: 3.9502,
    width: 2.65,
    height: 8,
    transform: "rotate(90 30.175 3.9502)",
    fill: "#FF00FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.6cf27bbc2fc4d32bb197b5295c0bd833.svg";
export { ForwardRef as ReactComponent };